module.exports = __webpack_public_path__ + "img/21_24.1f3afb35.png";